import React, { useState, useEffect } from 'react';
import './css/Custom.css';
import {
  Container,
  Navbar,
  Modal,
  Button,
  Form,
  Offcanvas,
} from 'react-bootstrap';
import { Link } from 'react-router-dom';
import config from '../../config/config';
import { FaSun, FaMoon } from 'react-icons/fa'; // Import icons
import { useAccount } from 'wagmi';
import { useWeb3Modal } from '@web3modal/wagmi/react';

const DashboardHeader = () => {
  const [show, setShow] = useState(false);
  const { isConnected, address, chainId, chain } = useAccount();
  const { isOpen, open, close } = useWeb3Modal();

  const [darkMode, setDarkMode] = useState(() => {
    return localStorage.getItem('theme') === 'dark';
  });

  const showWallet = (e) => {
    e.preventDefault();
    try {
      open();
    } catch (error) {
      console.log('Err', error);
    }
  };

  // Update the body class when darkMode changes
  useEffect(() => {
    if (darkMode) {
      document.body.classList.add('dark-mode');
      document.body.classList.remove('light-mode');
      localStorage.setItem('theme', 'dark');
    } else {
      document.body.classList.add('light-mode');
      document.body.classList.remove('dark-mode');
      localStorage.setItem('theme', 'light');
    }
  }, [darkMode]);

  return (
    <>
      <div className="header">
        {['lg'].map((expand) => (
          <Navbar
            key={expand}
            expand={expand}
            className=" navbar-background"
            style={{ minHeight: '70px' }}
          >
            <Container fluid className="py-1">
              <div className="d-flex align-items-center d-lg-none w-100">
                <Navbar.Brand
                  // style={{ backgroundColor: "red" }}
                  className=" w-100  d-flex justify-content-center align-items-center "
                >
                  <Link to={`${config.baseUrl}newdashboard`} className="">
                    <img
                      src={`${config.baseUrl}images/logos/logoMultichain.png`}
                      style={{ width: 200, height: 53, marginLeft: 25 }}
                      className="object-fit-contain logoLaunchpad"
                      alt=""
                    />
                  </Link>
                </Navbar.Brand>
                <Navbar.Toggle
                  aria-controls={`offcanvasNavbar-expand-${expand}`}
                />
              </div>
              <Navbar.Offcanvas
                className="offcanvas-body01"
                id={`offcanvasNavbar-expand-${expand} `}
                aria-labelledby={`offcanvasNavbarLabel-expand-${expand}`}
                placement="end"
              >
                <Offcanvas.Header className="navbar-background" closeButton>
                  <Offcanvas.Title id={`offcanvasNavbarLabel-expand-${expand}`}>
                    <Link to={`${config.baseUrl}newdashboard`} className="">
                      <img
                        src={`${config.baseUrl}images/logos/logoMultichain.png`}
                        style={{ width: 200, height: 53, marginLeft: 25 }}
                        className="object-fit-contain"
                        alt=""
                      />
                    </Link>
                  </Offcanvas.Title>
                </Offcanvas.Header>
                <Offcanvas.Body className="offcanvas-body01 justify-content-end">
                  <div className="d-flex flex-row flex-wrap gap-3 align-self-stretch">
                    <Form>
                      <div className="switchBtn">
                        <label
                          className={`theme-switch ${
                            darkMode ? 'dark' : 'light'
                          }`}
                        >
                          <input
                            type="checkbox"
                            checked={darkMode}
                            onChange={() => setDarkMode(!darkMode)}
                          />
                          <span className="slider">
                            <span className="text">
                              {darkMode ? 'Dark' : 'Light'}
                            </span>
                            <span className="icon">
                              {darkMode ? <FaMoon /> : <FaSun />}
                            </span>
                          </span>
                        </label>
                      </div>
                    </Form>
                    <Form className="d-sm-flex align-items-center justify-content-end">
                      <h4 className="text-gradient">
                        <b>
                          {console.log('qqqq', isConnected, address, chainId)}
                        </b>
                      </h4>
                      <div className="">
                        <div className="connect-btn d-flex ">
                          {chain && (
                            <>
                              <span
                                style={{
                                  display: 'inline-block',
                                  width: '8px',
                                  height: '8px',
                                  backgroundColor: 'lightgreen',
                                  borderRadius: '50%',
                                  marginRight: '6px',
                                  marginTop: '15px',
                                }}
                              ></span>
                              <span
                                style={{
                                  className: 'me-xxl-3 ',
                                  fontWeight: 'bold',
                                  whiteSpace: 'nowrap',
                                  marginRight: '20px',
                                  marginTop: '5px',
                                }}
                              >
                                {isConnected ? chain.name.toString() : ''}
                              </span>
                            </>
                          )}
                          <Button
                            variant="primary"
                            className="text-nowrap rounded-5 px-4"
                            style={{ fontSize: '14px' }}
                            onClick={(e) => showWallet(e)}
                          >
                            {isConnected
                              ? address.toString().substring(0, 4) +
                                '....' +
                                address
                                  .toString()
                                  .substring(address.length - 4, address.length)
                              : 'Connect Wallet'}
                          </Button>
                        </div>
                      </div>
                    </Form>
                  </div>
                </Offcanvas.Body>
              </Navbar.Offcanvas>
            </Container>
          </Navbar>
        ))}
      </div>

      <Modal show={show} size="lg" centered backdropClassName="custom-backdrop">
        <Modal.Body closeButton>
          <div>{/* <LoginHome /> */}</div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default DashboardHeader;
